const root = document.documentElement;
root.classList.add('vendmont-js');

try {
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  let revealObserver;

  const registerRevealItems = (scope = document) => {
    const items = [];
    if (scope instanceof Element && scope.matches('[data-vendmont-reveal]')) items.push(scope);
    items.push(...scope.querySelectorAll('[data-vendmont-reveal]'));

    items.forEach((item) => {
      if (motionQuery.matches || !revealObserver) {
        item.classList.add('is-visible');
      } else {
        revealObserver.observe(item);
      }
    });
  };

  if (!motionQuery.matches && 'IntersectionObserver' in window) {
    revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
  }

  registerRevealItems();

  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) registerRevealItems(node);
      });
    });
  });
  mutationObserver.observe(document.documentElement, { childList: true, subtree: true });

  root.dataset.vendmontReady = 'true';
} catch {
  root.classList.remove('vendmont-js');
  document.querySelectorAll('[data-vendmont-reveal]').forEach((item) => item.classList.add('is-visible'));
}
